import { render, staticRenderFns } from "./zystHome.vue?vue&type=template&id=52ef352a&scoped=true"
import script from "./zystHome.vue?vue&type=script&lang=js"
export * from "./zystHome.vue?vue&type=script&lang=js"
import style0 from "./zystHome.vue?vue&type=style&index=0&id=52ef352a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef352a",
  null
  
)

export default component.exports